import { SecurityConfigDTO, SecurityConfigRequestDTO } from "Interface/Admin/Configuration/security-config.interface";
import { ResultsDTO } from "Types/ResultsDTO";
import { ApiService } from "Services/ApiService";

export const SecurityConfigApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        getSecurityConfig: builder.query<ResultsDTO<SecurityConfigDTO>, void>({
            query: () => ({
                url: "/admin/security-config/",
                method: "GET",
                headers: {
                    origin: window.location.origin,
                },
            }),
            providesTags: ["SecurityConfig"],
        }),

        saveOrUpdateSecurityConfig: builder.mutation<ResultsDTO<number>, SecurityConfigRequestDTO>({
            query: (securityConfig) => ({
                url: "/admin/security-config/create-update",
                method: "POST",
                body: securityConfig,
                headers: {
                    origin: window.location.origin,
                },
            }),
            invalidatesTags: ["SecurityConfig"],
        })
    }),
});

export const {
    useGetSecurityConfigQuery,
    useSaveOrUpdateSecurityConfigMutation
} = SecurityConfigApiSlice;
